// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3pbfj","list":"PatternAutocomplete_list__elXBn"};